// Webpack Imports
import * as bootstrap from 'bootstrap';


( function () {
	'use strict';

	// Focus input if Searchform is empty
	[].forEach.call( document.querySelectorAll( '.search-form' ), ( el ) => {
		el.addEventListener( 'submit', function ( e ) {
			var search = el.querySelector( 'input' );
			if ( search.value.length < 1 ) {
				e.preventDefault();
				search.focus();
			}
		} );
	} );

	// Initialize Popovers: https://getbootstrap.com/docs/5.0/components/popovers
	var popoverTriggerList = [].slice.call( document.querySelectorAll( '[data-bs-toggle="popover"]' ) );
	var popoverList = popoverTriggerList.map( function ( popoverTriggerEl ) {
    console.log(this, popoverTriggerEl)
		return new bootstrap.Popover( popoverTriggerEl, {
			trigger: 'focus',
		} );
	} );

  var parallaxElements = document.getElementsByClassName('parallax');
  for (var i = 0; i < parallaxElements.length; i++) {
    var el = parallaxElements[i];
    var img = el.getElementsByTagName('img')[0];
    el.setAttribute('style', 'background:url(' + img.src + ') 50% 50% / cover fixed');
    el.classList.add('activated');
    img.remove();
  }
} )();

document.addEventListener('DOMContentLoaded', function(event) { 
  document.addEventListener('scroll', function(e) {
    var menu = document.querySelector('.navbar');
    menu.classList.toggle('scrolled', window.scrollY > 0);
  });
});